import React from "react";
import MainFloorPlanner from "../../../components/Planner/FloorPlanner";

export default function FloorPlan() {
  return <MainFloorPlanner />;
}
